import React from "react";
import PropTypes from "prop-types";
import { RPMDisplay } from "../RPMDisplay";
import { ButtonControls } from "../ButtonControls";
import { useTranslation } from "react-i18next";

import "./style.scss";

const TRANSLATION_KEY = {
  RPM: "RPM.string",
  SET_RPM: "SetRPM.string",
  INCREASE_RPM_BUTTON: "IncreaseRPMButton.string",
  DECREASE_RPM_BUTTON: "DecreaseRPMButton.string",
};

export function RPMBlock(props) {
  const incrementRPM = () => {
    props.setRPM(props.value + 500);
  };
  const decrementRPM = () => {
    props.setRPM(props.value - 500);
  };

  const { t } = useTranslation();

  return (
    <div className="mc_settings_rpm">
      <h5 className="mc_settings_rpm_title">{t(TRANSLATION_KEY.SET_RPM)}</h5>
      <RPMDisplay displayValue={props.value} setRPM={props.setRPM} />
      <div className="mc_settings_rpm_controlBlock">
        <ButtonControls
          text={t(TRANSLATION_KEY.RPM)}
          increment={incrementRPM}
          decrement={decrementRPM}
          altText1={t(TRANSLATION_KEY.INCREASE_RPM_BUTTON, {
            rpm: props.value,
          })}
          altText2={t(TRANSLATION_KEY.DECREASE_RPM_BUTTON, {
            rpm: props.value,
          })}
        />
      </div>
    </div>
  );
}

RPMBlock.propTypes = {
  /**
   * rpm value to be displayed
   */
  value: PropTypes.number,

  ...RPMDisplay.propTypes,
};

RPMBlock.defaultProps = {};
